    <div class = "view-for-label">View for</div>
    <div class="view-for-input dropdown-ind ms-3">
        <a>
            <select (change)="onSelectChange($event.target.value)" [(ngModel)]="selectedValue">
                <option value="7">7 Days</option>
                <option value="14">2 Weeks</option>
                <option value="30">1 Month</option>
                <option value="90">3 Months</option>
                <option value="-1">ALL</option>
            </select>
        </a>
    </div>
